// Module
var code = "<div class=\"drilldown-popup-main\">\n    <div class=\"item\">\n        <a ng-href eat-click-if=\"!hasPermission('interests')\" ng-click=\"drillDown('interests.board')\">See more</a>\n    </div>\n</div>\n";
// Exports
module.exports = code;